import React from 'react'
import { Card, Typography } from "antd";

const { Title } = Typography

type Props = {
  startTime: string;
  endTime: string;
}

const AvailableTimeCard: React.FC<Props> = ({
  startTime,
  endTime
}) => {
  return <Card className="time-range-card">
    <Title level={4}>
      <span className="primary-text">{startTime} - {endTime}</span>
    </Title>
  </Card>
}

export default AvailableTimeCard;